import { useCallback } from 'react';
import { useRouter } from '@/navigation';
import {
	WC_PROMOTION_PARTY_TAB_STARTS_AT_MS,
	WC_PROMOTION_SPIN_TAB_STARTS_AT_MS,
} from '../constants';

type WcPromotionActivityTab = 'lottery' | 'spin' | 'party';

const getWcPromotionActivityTabAt = (nowMs: number): WcPromotionActivityTab => {
	if (nowMs >= WC_PROMOTION_PARTY_TAB_STARTS_AT_MS) {
		return 'party';
	}
	if (nowMs >= WC_PROMOTION_SPIN_TAB_STARTS_AT_MS) {
		return 'spin';
	}
	return 'lottery';
}

const getWcPromotionActivityHrefAt = (nowMs: number): string => {
	const tab = getWcPromotionActivityTabAt(nowMs);
	return `/wc-promotion?tab=${tab}`;
}

export const useWcPromotionActivityNavigation = () => {
	const router = useRouter();

	const navigateToWcPromotionActivity = useCallback(() => {
		router.push(getWcPromotionActivityHrefAt(Date.now()));
	}, [router]);

	return { navigateToWcPromotionActivity };
}
